import { Component, OnInit, OnDestroy, inject } from '@angular/core';

import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { ProgressService, ProgressState } from '../../../../shared/progress.service';
import { AuthInterceptor } from '../../../../shared/auth.interceptor';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

/** App-wide progress bar displayed below the top app bar during long-running operations, with cold-start messaging support. */
@Component({
  selector: 'app-global-progress',
  imports: [MatProgressBarModule, MatIconModule],
  templateUrl: './global-progress.component.html',
  styleUrls: ['./global-progress.component.scss'],
})
export class GlobalProgressComponent implements OnInit, OnDestroy {
  private progressService = inject(ProgressService);

  progressState: ProgressState = {
    isLoading: false,
    message: '',
    isColdStart: false,
    progress: 0,
  };

  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.progressService.progress$.pipe(takeUntil(this.destroy$)).subscribe(state => {
      this.progressState = state;
    });

    AuthInterceptor.coldStartRetry$.pipe(takeUntil(this.destroy$)).subscribe(retryState => {
      if (retryState.isRetrying && !this.progressService.isActive()) {
        this.progressState = {
          isLoading: true,
          message: 'Waking up server...',
          isColdStart: true,
          progress: 0,
        };
      } else if (!retryState.isRetrying && this.progressState.message === 'Waking up server...') {
        this.progressState = {
          isLoading: false,
          message: '',
          isColdStart: false,
          progress: 0,
        };
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
